import { SquadInvite } from "../../types/squads";

export const rejectSquadInviteModel = (
  response: SquadInvite
): SquadInvite => response;
